<template>
 <v-dialog
    v-model="show"
    max-width="1000"
    @click:outside="cancel">
    <v-card
      v-if="show">
        <v-toolbar short dark color="primary">
          <v-btn icon dark @click="cancel">
              <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
              {{$t("common.search")}}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form v-model="searchParamsValid" class="mx-3 mt-2">
            <v-row align="center" class="mt-3">
              <v-col cols=12 md=6>
                <v-select
                  :items="operators"
                  v-model="editableSearchParams.companyId"
                  label="Company"
                ></v-select>
              </v-col>
              <v-col cols=12 md=6>
                <v-text-field
                    v-model="editableSearchParams.fleetId"
                    label="Fleet"
                ></v-text-field>
              </v-col>
              <v-col cols=12 md=4>
                <v-text-field
                    v-model="editableSearchParams.latitude"
                    label="Latitude"
                ></v-text-field>
              </v-col>
              <v-col cols=12 md=4>
                <v-text-field
                    v-model="editableSearchParams.longitude"
                    label="Longitude"
                ></v-text-field>
              </v-col>
              <v-col cols=12 md=4>
                <v-text-field
                    v-model="editableSearchParams.maximumDistanceInMeters"
                    label="Maximum Distance In Meters"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="search">
              {{$t("common.search")}}
            </v-btn>
            <v-btn
              @click="cancel"
              class="ml-2">
              {{$t("common.cancel")}}
            </v-btn>
            <v-spacer></v-spacer>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from "lodash";

export default {
    props: {
        show: Boolean,
        searchParams: Object
    },
    data() {
        return {
            editableSearchParams: _.cloneDeep(this.searchParams),
            searchParamsValid: true
        };
    },
    watch: {
        searchParams(val) {
            if (!val) {
                this.editableSearchParams = null;
            } else {
                this.editableSearchParams = _.cloneDeep(val);
            }
        }
    },
    computed: {
        operators() {
            return _.filter(this.$store.state.user.operators, function(o) { return o !== "all"; });
        }
    },
    methods: {
        search() {
            const params = {
                companyId: this.editableSearchParams.companyId,
                fleetId: this.editableSearchParams.fleetId,
                query: {
                    point: {
                        latitude: this.editableSearchParams.latitude,
                        longitude: this.editableSearchParams.longitude
                    },
                    maximumDistanceInMeters: this.editableSearchParams.maximumDistanceInMeters
                }
            };

            this.$emit("search", params);
        },
        cancel() {
            this.$emit("close");
        }
    }
};
</script>
